module.exports = "<p>\n  ver-requisito-becario works!\n</p>\n"